import {
	CLASSES_CREATE_CLASSES,
	CLASSES_CREATE_CLASSES_FAILURE,
	CLASSES_CREATE_CLASSES_SUCCESS,
	CLASSES_EDIT_CLASSES,
	CLASSES_EDIT_CLASSES_FAILURE,
	CLASSES_EDIT_CLASSES_SUCCESS,
	CLASSES_GET_CLASSES,
	CLASSES_GET_CLASSES_FAILURE,
	CLASSES_GET_CLASSES_SUCCESS,
	CLASSES_PROPS_CHANGED, CLASSES_REMOVE_CLASSES, CLASSES_REMOVE_CLASSES_FAILURE, CLASSES_REMOVE_CLASSES_SUCCESS
} from "./actions";
import {find, removeElem, updateElemByIndex} from "../../utility/functions";

const initialState = {
	loading: false,
	creating: false,
	editing: false,
	removing: false,
	showEditModal: false,
	showRemoveModal: false,
	classes: null,
	classInfo: null,
	index: null,
	name: "",
	password: "",
	info: "",
};

export const classesReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case CLASSES_GET_CLASSES:
			return {
				...state,
				loading: true,
			};
		case CLASSES_GET_CLASSES_SUCCESS:
			return {
				...state,
				classes: action.classes,
				pagination: action.pagination,
				loading: false,
			};
		case CLASSES_GET_CLASSES_FAILURE:
			return {
				...state,
				loading: false,
			};
		case CLASSES_CREATE_CLASSES:
			return {
				...state,
				creating: true,
			};
		case CLASSES_CREATE_CLASSES_SUCCESS:
			return {
				...state,
				creating: false,
				classes: [...state.classes, action.class],
				name: "",
				password: "",
				info: "",
			};
		case CLASSES_CREATE_CLASSES_FAILURE:
			return {
				...state,
				creating: false,
			};
		case CLASSES_EDIT_CLASSES:
			return {
				...state,
				editing: true,
			};
		case CLASSES_EDIT_CLASSES_SUCCESS:
			return {
				...state,
				classes: updateElemByIndex(state.classes, action.class, state.index),
				editing: false,
				showEditModal: false,
				index: null,
				classInfo: null,
			};
		case CLASSES_EDIT_CLASSES_FAILURE:
			return {
				...state,
				editing: false,
			};
		case CLASSES_REMOVE_CLASSES:
			return {
				...state,
				removing: true,
			};
		case CLASSES_REMOVE_CLASSES_SUCCESS:
			return {
				...state,
				classes: removeElem(state.classes, 'id', find(state.classInfo, 'id')),
				removing: false,
				showRemoveModal: false,
				index: null,
				classInfo: null,
			};
		case CLASSES_REMOVE_CLASSES_FAILURE:
			return {
				...state,
				removing: false,
			};
		case CLASSES_PROPS_CHANGED :
			return {
				...state,
				...action,
			};
		default:
			return state;
	}
};